import { render, staticRenderFns } from "./singleCardGroup.vue?vue&type=template&id=a60c103a&scoped=true&"
import script from "./singleCardGroup.vue?vue&type=script&lang=js&"
export * from "./singleCardGroup.vue?vue&type=script&lang=js&"
import style0 from "./singleCardGroup.vue?vue&type=style&index=0&id=a60c103a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60c103a",
  null
  
)

export default component.exports